/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TournamentRegistrationFieldPreference
 */
export interface TournamentRegistrationFieldPreference {
    /**
     * 
     * @type {string}
     * @memberof TournamentRegistrationFieldPreference
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentRegistrationFieldPreference
     */
    fieldName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentRegistrationFieldPreference
     */
    isVisible?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentRegistrationFieldPreference
     */
    isRequired?: boolean;
}

/**
 * Check if a given object implements the TournamentRegistrationFieldPreference interface.
 */
export function instanceOfTournamentRegistrationFieldPreference(value: object): value is TournamentRegistrationFieldPreference {
    return true;
}

export function TournamentRegistrationFieldPreferenceFromJSON(json: any): TournamentRegistrationFieldPreference {
    return TournamentRegistrationFieldPreferenceFromJSONTyped(json, false);
}

export function TournamentRegistrationFieldPreferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentRegistrationFieldPreference {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'fieldName': json['fieldName'] == null ? undefined : json['fieldName'],
        'isVisible': json['isVisible'] == null ? undefined : json['isVisible'],
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
    };
}

export function TournamentRegistrationFieldPreferenceToJSON(json: any): TournamentRegistrationFieldPreference {
    return TournamentRegistrationFieldPreferenceToJSONTyped(json, false);
}

export function TournamentRegistrationFieldPreferenceToJSONTyped(value?: TournamentRegistrationFieldPreference | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fieldName': value['fieldName'],
        'isVisible': value['isVisible'],
        'isRequired': value['isRequired'],
    };
}

